// noop: provenance proof
import './env-shim'; // must be first
import "./polyfills/process-shim";
// MUST run first — sets emulator/auto-login & health beacons
import '@orrekie/shared/runtime/bootstrap';
import './index.css';
import '@orrekie/ui-chrome/tokens.css'; // MUST be after index.css to override app styles
import '@orrekie/ui-chrome/fonts.css';
import '@orrekie/ui-chrome/chrome.css';
import '@orrekie/ui-chrome/mosaic.css'; // Mosaic verbatim styles for dashboard

import { ThemeProvider } from '@orrekie/ui';

import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';


import AppShell from './AppShell';
import { initFirebase } from './firebase/init';

// Initialize Firebase BEFORE routes render
initFirebase();

// DEV-only components - lazy loaded and tree-shaken in production
const TwProbes = import.meta.env.DEV
  ? lazy(() => import('./components/dev/TwProbes'))
  : null;

declare global {
  interface Window {
    __ORREKIE_DEBUG?: string;
  }
}

window.__ORREKIE_DEBUG = 'ping';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      {import.meta.env.DEV && TwProbes && (
        <Suspense fallback={null}>
          <TwProbes />
        </Suspense>
      )}
      <AppShell />
    </ThemeProvider>
  </StrictMode>,
);
